import { IListResponse } from 'src/app/core';
import { IFile } from './file.interface';
import { IDenoisedMetric, IMetric } from '../charts';
import { InputNumber } from 'ng-zorro-antd/core/util';

export interface IFileListResponse extends IListResponse<IFile> {
  pepAverage: number;
  lvetAverage: number;
  ivctAverage: number;
  ntProBnpAverage: number;
}

export interface IFileMetricsResponse {
  ivctMetrics: IMetric[];
  lvetMetrics: IMetric[];
  pepMetrics: IMetric[];
  nTproBNPs: IMetric[];
}

export interface IDenoisedFileMetricsResponse {
  ecgDenoisedDataForChartDto: IEcgDenoised;
  pcgDenoisedDataForChartDto: IPcgDenoised;
  ppgDenoisedDataForChartDto: IPpgDenoised;
  pepLinesMeasurements: ILineMeasurement[];
  lvetLinesMeasurements: ILineMeasurement[];
  ivctLinesMeasurements: ILineMeasurement[];
  fileId: string;
}

export interface IEcgDenoised {
  ecgFiltered: IDenoisedMetric[];
  ecgQ: IDenoisedMetric[];
  ecgQRaw: IDenoisedMetric[];
  ecgR: IDenoisedMetric[];
  ecgRRaw: IDenoisedMetric[];
}

export interface IPcgDenoised {
  pcgFiltered: IDenoisedMetric[];
  pcgPointsRaw: IDenoisedMetric[];
  pcgS1: IDenoisedMetric[];
  pcgS2: IDenoisedMetric[];
}

export interface IPpgDenoised {
  ppgFiltered: IDenoisedMetric[];
  ppgFootrise: IDenoisedMetric[];
  ppgPointsRaw: IDenoisedMetric[];
}

export interface ILineMeasurement {
  firstLinePoint: ILinePoint;
  secondLinePoint: ILinePoint;
  value: number;
}

export interface ILinePoint {
  xCoordinate: number;
  yCoordinate: number;
}
